"use client";

import React from "react";
import { toast } from "sonner";
import { useFloorPlansState } from "@/components/providers/FloorPlansStateProvider/floor-plans-state-provider";
import Container from "@/components/ui/layout/container";
import Section from "@/components/ui/layout/section";
import type { FloorPlanName } from "../../types";
import FloorPlansListItem from "./floor-plans-list-item";

export const SECTION_ID = "floor-plans-list";

function FloorPlansList() {
  const { folders, folderError } = useFloorPlansState();

  React.useEffect(() => {
    if (!folderError) {
      return;
    }

    toast.error(
      `Oops! It seems that the floor plans failed to fetch. Please check your internet connection or try again! Thank you.`,
    );
  }, [folderError]);

  if (folderError) {
    return null;
  }

  return (
    <Section id={SECTION_ID}>
      <Container id={SECTION_ID} maxWidth="max-w-7xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {folders?.map(({ name }) => (
            <FloorPlansListItem
              key={name}
              title={name as FloorPlanName}
            />
          ))}
        </div>
      </Container>
    </Section>
  );
}

export default FloorPlansList;
